import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import AddToBasketRoundedButton from "../addToBasketRoundedButton";
import { IconBasket1 } from "../../../assets/icons";

function SkeletonDetailsContetnt() {
  return (
    <>
      <Card className="p-2 rounded-3 text-center">
        <Skeleton width="174px" height="138px"></Skeleton>
        <Card.Body className="px-0 pb-0">
          <Skeleton height="15px"></Skeleton>
        </Card.Body>
        <Card.Footer className="border-top-0 pb-0 pe-1 pt-2 bg-white">
          <Row className="gx-0">
            <Col className="my-auto pe-3">
              <Skeleton height="13px"></Skeleton>
              <div className="fw-bold text-black">
                <Skeleton height="13px"></Skeleton>
              </div>
            </Col>
            <Col xs="auto" className="my-auto">
              <button className="bg-gray-4 btn-rounded">
                <IconBasket1 fillColor="#fff" />
              </button>{" "}
            </Col>
          </Row>
        </Card.Footer>
      </Card>
    </>
  );
}

export default SkeletonDetailsContetnt;
